import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import ClientDB from './rahmen/clientDB'
import resize from 'vue-element-resize-detector'
import VModal from 'vue-js-modal'
import VCalendar from 'v-calendar'
import VueTour from 'vue-tour'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { AgGridVue } from 'ag-grid-vue'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import 'ag-grid-community/styles/ag-theme-balham.css'
import 'ag-grid-community/styles/ag-theme-material.css'

require('vue-tour/dist/vue-tour.css')

Vue.use(VModal)
Vue.use(VCalendar, {
  componentPrefix: 'vc'
})
Vue.use(VueTour)
Vue.config.productionTip = false
Vue.use(VueQuillEditor)
if (Vue.config.productionTip) {
  console.log = () => { }
}

Vue.component('AgGridVue', AgGridVue)

// indexedDBのマイグレーション
const db = new ClientDB('')
db.upgrade()

Vue.router = router

new Vue({
  router,
  store,
  vuetify,
  resize,
  render: h => h(App)
}).$mount('#app')
